import axios from 'axios';

const BASE_URL = 'https://pest-routes-tipping-az-c5101334ece4.herokuapp.com';

export const createRating = async (tipRequestId, rating) => {

    const response = await axios.post(`${BASE_URL}/api/v1/ratings`, {
        tip_request_id: parseInt(tipRequestId, 10),
        rating: rating
    });

    return response.data;
}

export const submitFeedback = async (ratingId, feedback) => {

    const response = await axios.patch(`${BASE_URL}/api/v1/ratings/${ratingId}`, {
        feedback: feedback
    });

    return response.data;
}
